"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const O = require("fp-ts/lib/Option");
const pipeable_1 = require("fp-ts/lib/pipeable");
const domain_1 = require("./domain");
const re = /^(0|[1-9]\d*)(?:[,.](\d{0,2}))?$/;
function parse(value) {
    const sign = value.slice(0, 1) === '-' ? -1 : 1;
    const candidate = value.replace('-', '');
    return pipeable_1.pipe(candidate.match(re), O.fromNullable, O.map(m => {
        const [wholes, remainder] = m.slice(1);
        return new domain_1.EuroCents((wholesToCents(wholes) + remainderToCents(remainder)) * sign);
    }));
}
exports.parse = parse;
function wholesToCents(wholes) {
    return Number.parseInt(wholes, 10) * 100;
}
function remainderToCents(remainder) {
    return pipeable_1.pipe(remainder, O.fromNullable, O.map(x => {
        const rightPadded = x.length >= 2 ? x.substring(0, 2) : x + '0'.repeat(2 - x.length);
        return Number.parseInt(rightPadded, 10);
    }), O.getOrElse(() => 0));
}
